exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#service_request_form .terms_condition[data-v-056fbeea] {\n  cursor: pointer;\n}", ""]);

// exports
